import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { DriverDetailContent } from './DriverDetailContent';

export function DriverDetail() {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) {
    return <Alert severity="error">Missing driver id.</Alert>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <Button
        startIcon={<ArrowBackIcon />}
        size="small"
        onClick={() => navigate('/drivers')}
        sx={{ mb: 2, color: 'text.secondary', alignSelf: 'flex-start' }}
      >
        Back to Drivers
      </Button>

      <DriverDetailContent
        driverId={id}
        onReleased={() => window.setTimeout(() => navigate('/drivers'), 900)}
      />
    </Box>
  );
}
